/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const GlobalLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20m-2.29-2.33A18 18 0 0 1 8.03 13H4.06a8 8 0 0 0 5.65 6.67m.32-6.67A16 16 0 0 0 12 19.75 16 16 0 0 0 13.97 13zm9.9 0h-3.96a18 18 0 0 1-1.68 6.67A8 8 0 0 0 19.94 13M4.07 11h3.97A18 18 0 0 1 9.7 4.33 8 8 0 0 0 4.06 11m5.97 0h3.94A16 16 0 0 0 12 4.25 16 16 0 0 0 10.03 11m4.26-6.67A18 18 0 0 1 15.97 11h3.97a8 8 0 0 0-5.65-6.67" />
  </Icon>
);
